const clamp = (number, min, max) => Math.min(Math.max(number, min), max);

export { clamp };
